import "./index.scss";
import Lottie from "react-lottie-player";
import an404 from "../../../assets/animations/an-404.json";

const NotFound = () => {
  return (
    <div id="not-found-container" className="center-all">
      <Lottie
        loop
        animationData={an404}
        play
        style={{
          width: "100vw",
          height: "70vh",
          position: "relative",
          top: "10%",
        }}
      />
    </div>
  );
};

export default NotFound;
